export default "__VITE_ASSET__CeaCB9LD__"